import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            分类浏览
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            按你喜欢的类型探索漫画世界，总有一类适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`group rounded-lg p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                index === 0
                  ? "bg-foreground-950 text-background-50"
                  : "bg-background-100 hover:bg-background-200/70"
              }`}
            >
              <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-4 ${
                index === 0 ? "bg-primary-500/20" : "bg-primary-100"
              }`}>
                <i className={`ri-book-2-line text-lg ${index === 0 ? "text-primary-400" : "text-primary-500"}`}></i>
              </div>
              <h3 className={`font-heading text-base font-bold mb-2 ${index === 0 ? "text-background-50" : "text-foreground-950"}`}>
                {cat.name}
              </h3>
              <p className={`text-xs mb-3 line-clamp-2 ${index === 0 ? "text-background-300" : "text-foreground-500"}`}>
                {cat.description}
              </p>
              <span className={`text-xs font-medium ${index === 0 ? "text-primary-400" : "text-primary-500"}`}>
                {cat.count.toLocaleString()}部
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}